// IE 2026 11 03 / ODOO-350449 (activity ping)
// Пинг активности вкладки: раз в fe.activity.pingMs (60 с) фронт шлёт бэку executeBackendMethod activity_ping, если вкладка ВИДИМА и
// пользователь что-то вводил (pointerdown / keydown / wheel / touchstart) за последние fe.activity.idleMs (120 с). Бэк
// (common_modules/activity_log.py) копит это в одной строке work.logs LOGS-activity на (пользователь, вкладка, 5-минутный слот) —
// страница «User activity» видит активное время, «открыл и ушёл» и параллельные вкладки, а не только построения отчётов (LOGS-usage).
//
// tab_id — uuid вкладки в sessionStorage (переживает F5, новая вкладка — новый id); тот же id уходит в client.tab_id запросов виджетов
// (mainStore.client_requestParams) — события LOGS-usage тоже получают вкладку.
// Запрос — как опрос autoRecalc_check: прямой $.ajax (заголовки базы из $.ajaxSetup / ajaxPrefilter), без спиннера, тостов и TERMINAL;
// ошибки глотаются молча.
// Выключатель (правило 8, дефолт ВКЛ): fe.activity.ping (window.feSettings.set('fe.activity.ping', false) или ?fe.activity.ping=false);
// бэк — not-activity_log / not-usage_log.

export const FLAG_PING = 'fe.activity.ping'
export const KEY_PING_MS = 'fe.activity.pingMs'
export const KEY_IDLE_MS = 'fe.activity.idleMs'
export const DEFAULT_PING_MS = 60000
export const DEFAULT_IDLE_MS = 120000
export const TAB_KEY = 'fe.activity.tabId'
export const METHOD = 'activity_ping'
const INPUT_EVENTS = ['pointerdown', 'keydown', 'wheel', 'touchstart']

const state = { started: false, timer: null, lastInputAt: 0, inputCount: 0, lastSentAt: 0, tabId: '', sent: 0, failed: 0 }

const num = (v, d) => { const n = Number(v); return Number.isFinite(n) && n > 0 ? n : d }

// настройки (читаются на каждом тике — флаг переключается без перезагрузки)
export function activityPing_settings(store) {
    const get = (k, d) => { try { return store && typeof store.setting === 'function' ? store.setting(k, d) : d } catch (e) { return d } }
    return { on: get(FLAG_PING, true) !== false, pingMs: num(get(KEY_PING_MS, DEFAULT_PING_MS), DEFAULT_PING_MS),
        idleMs: num(get(KEY_IDLE_MS, DEFAULT_IDLE_MS), DEFAULT_IDLE_MS) }
}

// слать ли пинг сейчас: флаг включён, вкладка видима, ввод был не раньше idleMs назад
export function activityPing_should({ on = true, visible, now, lastInputAt, idleMs = DEFAULT_IDLE_MS }) {
    if (!on || visible !== 'visible') return false
    if (!lastInputAt) return false
    return now - lastInputAt < idleMs
}

function _uuid() {
    try { if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID() } catch (e) { /* старый браузер */ }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => { const r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16) })
}

// uuid вкладки: sessionStorage (переживает F5); хранилище недоступно — id на загрузку страницы
export function activityPing_tabId(storage) {
    if (state.tabId) return state.tabId
    let st = storage
    try { if (st === undefined) st = typeof sessionStorage !== 'undefined' ? sessionStorage : null } catch (e) { st = null }
    let id = ''
    try { id = (st && st.getItem(TAB_KEY)) || '' } catch (e) { id = '' }
    if (!/^[A-Za-z0-9_-]{8,64}$/.test(id)) {
        id = _uuid()
        try { if (st) st.setItem(TAB_KEY, id) } catch (e) { /* приватный режим */ }
    }
    state.tabId = id
    return id
}

// где пользователь сейчас: стол, страница, активный виджет (id записи виджета)
export function activityPing_where(store) {
    const WS = store?.activeWORKSPACE
    const W = store?.activeWIDGET
    return {
        workspace: String(WS?.workspace || WS?.record?.id || ''),
        page: String(WS?.activePAGE?.page || ''),
        widget: String(W?.record?.id || W?.widget || W?.id || ''),
    }
}

// params запроса activity_ping
export function activityPing_params(store, { tabId, inputCount = 0, intervalS = DEFAULT_PING_MS / 1000, now = Date.now() } = {}) {
    return { tab_id: tabId || '', ...activityPing_where(store), input_count: Math.max(0, inputCount | 0), interval_s: Math.round(intervalS),
        client_ts: new Date(now).toISOString() }
}

function _send(store, params) {
    const $ = (typeof window !== 'undefined' && (window.$ || window.jQuery)) || null
    if (!$ || !store?.url_backend_api) return
    try {
        $.ajax({
            url: store.url_backend_api, type: 'POST', contentType: 'application/json', dataType: 'json',
            data: JSON.stringify({ command: 'executeBackendMethod', method: METHOD, params, user: store.user }),
            success: () => { state.sent++ },
            error: () => { state.failed++ },   // молча: пинг не критичен
        })
    } catch (e) { state.failed++ }
}

// один тик таймера (экспорт — для теста и консоли); send — транспорт (по умолчанию $.ajax)
export function activityPing_tick(store, { now = Date.now(), visible, send = _send } = {}) {
    const s = activityPing_settings(store)
    let vis = visible
    if (vis === undefined) { try { vis = document.visibilityState } catch (e) { vis = 'hidden' } }
    if (!activityPing_should({ on: s.on, visible: vis, now, lastInputAt: state.lastInputAt, idleMs: s.idleMs })) return false
    if (!store?.user) return false
    const intervalS = state.lastSentAt ? Math.min(s.pingMs, now - state.lastSentAt) / 1000 : s.pingMs / 1000
    const params = activityPing_params(store, { tabId: activityPing_tabId(), inputCount: state.inputCount, intervalS, now })
    state.inputCount = 0
    state.lastSentAt = now
    try { send(store, params) } catch (e) { /* молча */ }
    return true
}

const _onInput = () => { state.lastInputAt = Date.now(); state.inputCount++ }

// запуск один раз (App.vue mounted); период — fe.activity.pingMs на момент запуска
export function activityPing_start(store) {
    if (state.started) return
    state.started = true
    try {
        for (const ev of INPUT_EVENTS) document.addEventListener(ev, _onInput, { capture: true, passive: true })
    } catch (e) { /* без документа */ }
    activityPing_tabId()
    state.timer = setInterval(() => { try { activityPing_tick(store) } catch (e) { /* молча */ } }, activityPing_settings(store).pingMs)
    try { if (typeof window !== 'undefined') window.activityPing = { get: () => ({ ...activityPing_settings(store), ...state, timer: !!state.timer }), tick: () => activityPing_tick(store) } } catch (e) { /* без окна */ }
}

// тест: сброс состояния модуля
export function activityPing__reset(over = {}) {
    if (state.timer) clearInterval(state.timer)
    Object.assign(state, { started: false, timer: null, lastInputAt: 0, inputCount: 0, lastSentAt: 0, tabId: '', sent: 0, failed: 0 }, over)
}

export default { activityPing_start, activityPing_tick, activityPing_should, activityPing_params, activityPing_tabId, activityPing_settings }
